import { Modal, Row, Col, Form, message } from 'antd';
import CreateTaskForm from '../CreateTaskForm/CreateTaskForm';
import Task from '../../../models/Task';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import TaskType from '../../../models/TaskType';
import { createTask, getTaskTypeByUser, setShowTaskModal, selectShowTaskModal } from '../../../store/slice/taskSlice';
import { useNavigate } from 'react-router-dom';

/**
 * @component CreateTaskModal.tsx
 * @description CreateTaskModal component create task with title and type of task.
 * @return { Component }
 */
function CreateTaskModal() {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const [taskTypeAll, setTaskTypeAll] = useState<TaskType[]>([])
  let navigate = useNavigate();
  const showTaskModal = useAppSelector(selectShowTaskModal);


  const createPartialTask = (createTaskItem: Task) => {
    dispatch(createTask(createTaskItem)).then((value: any) => {
      if(value.payload.status){
        navigate('editar/' + value.payload.data?.id );
      }
      else{
        message.error(value.payload.data?.message);
      }
    });
  };
  
  const handleOk = () => {
    form
      .validateFields()
      .then((values: Task) => {
        createPartialTask(values);
        dispatch(setShowTaskModal(false));
        form.resetFields();
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const handleCancel = () => {
    dispatch(setShowTaskModal(false));
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
    dispatch(getTaskTypeByUser()).then((value: any) =>{
        if (value.payload.status) {
            let taskType = value.payload.data;
            setTaskTypeAll(taskType);
        } else {
            setTaskTypeAll([]);
        }
    });
  }, []);


  return (
    <div>
      <Row>
        <Col span={24}>
          <Modal
            title={
              'Crear Tarea'
            }
            visible={showTaskModal as boolean}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={'Crear Tarea'}
            width={373}
            centered={true}
            className={'org-task__modal'}
            cancelText='Cancelar'
            maskClosable={false}
          >
            <CreateTaskForm
              form={form}
              taskTypeAll={taskTypeAll}
            />
          </Modal>
        </Col>
      </Row>
    </div>
  );
}

export default CreateTaskModal;
